import React from 'react'

import { Container } from '../../components/Bootstrap'
import { Bar } from '../../components/Charts'
import Hero from '../../components/Hero'
import Layout from '../../components/Layout'
import Legend from '../../components/Legend'
import Navigation from '../../components/Navigation'
import Summary from '../../components/Summary'

import { bold } from '../../styles'

const AllFour = () => (
  <Layout>
    <Hero>
      <h1>Question 4</h1>
      <p className={bold}>Please indicated the importance of each of the following programs and/or services</p>
    </Hero>
    <Container>
      <Navigation prev="/all/3" next="/all/5" />
      <Legend>
        <div>Very Important</div>
        <div>Important</div>
        <div>Not Important</div>
        <div>I don't know</div>
      </Legend>
      <Bar
        data={{
          labels: [ 'Service Navigation', 'Peer Support', 'Parenting with a Disability Network', 'Independant Living Skills Training', 'Attendant Services Application Centre (ASAC)', 'Direct Funding', 'Student Attendant Service Fund', 'Networking', 'Diners Club' ],
          series: [
            [ 69.23, 64.29, 52.83, 59.26, 75.00, 84.31, 48.56, 48.56, 32.00 ],
            [ 28.85, 28.57, 33.95, 33.33, 15.38, 7.54, 24.49, 40.82, 37.74 ],
            [ 0, 1.79, 3.77, 1.65, 0, 0, 0, 2.04, 12.21 ],
            [ 1.92, 5.36, 9.43, 5.56, 9.26, 7.84, 26.53, 8.16, 16.95 ]
          ]
        }}
        options={{
          axisY: {
            offset: 60,
            scaleMinSpace: 30,
          },
          axisX: {
            offset: 100,
          },
          height: '500px',
          width: '100%',
          high: 90,
          seriesBarDistance: 14
        }}
        caption="Please indicated the importance of each of the following programs and/or services"
        header="Importance"
      />
	  <Summary>The graph shows that the programs respondents indicated are “Very Important” are in descending order: Direct Funding, Attendant Services Application Centre, Service Navigation, Peer Support, Independent Living Skills Training, Parenting with a Disability Network, Student Attendant Service Fund, Networking and Diners Club.</Summary>
    </Container>
  </Layout>
)

export default AllFour
